import { render, staticRenderFns } from "./TemplateServices.vue?vue&type=template&id=50a83047&scoped=true"
import script from "./TemplateServices.vue?vue&type=script&lang=js"
export * from "./TemplateServices.vue?vue&type=script&lang=js"
import style0 from "./TemplateServices.vue?vue&type=style&index=0&id=50a83047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a83047",
  null
  
)

export default component.exports